import styled from '@emotion/styled';
import { Formik, FormikConfig, FormikProps } from 'formik';
import { ReactNode } from 'react';
import ItemList from './ItemList';
import QuickSelect from './QuickSelect';
import { FV } from './share';

const Container = styled.div`
  display: flex;
  align-items: stretch;
  height: 564px;
  overflow: hidden;
  > div {
    flex: 0 0 230px;
    border-right: none;
  }
  > section {
    flex: 1 0 0;
    overflow: hidden;
    > div {
      height: 100%;
      width: 100%;
    }
  }
`;

export interface ItemSelectFormProps extends FormikConfig<FV> {
  children: (form: ReactNode, formProps: FormikProps<FV>) => ReactNode;
}

function ItemSelectForm(props: ItemSelectFormProps) {
  const { children, ...otherProps } = props;

  return (
    <Formik enableReinitialize {...otherProps}>
      {(formProps) => {
        const form = (
          <Container>
            <QuickSelect />
            <section>
              <ItemList />
            </section>
          </Container>
        );

        return children(form, formProps);
      }}
    </Formik>
  );
}

export default ItemSelectForm;
